// extracted by mini-css-extract-plugin
export default {"list":"_b75dbbea","container":"_3148bfaf"};